import api from '../../../utils/api'

import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'

/* form */
import FormCost from './Form/FormCost'

function NewCost({ providerId, btCancelAction, handleOnSuccess }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerCost(cost) {
        let msgType = 'success'

        const data = await api.post('/cost/new', { ...cost, provider: providerId }, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <FormCost title="Cadastrar Custo por Unidade" handleSubmit={registerCost} btCancelAction={btCancelAction} btnText="Cadastrar" />
    )
}

export default NewCost
